import { createContext, useContext } from 'react';
export const AssociatedObjectsCardDataContext = /*#__PURE__*/createContext({
  isLoading: true,
  userPermissions: {
    currentUserCanEdit: false,
    currentUserCanEditAssociations: false,
    __typename: 'ObjectPermissions'
  }
});
export const useAssociatedObjectsCardDataContext = () => {
  const context = useContext(AssociatedObjectsCardDataContext);
  if (!context) {
    throw new Error('useAssociatedObjectsCardDataContext must be used within a AssociatedObjectsCardDataContext provider');
  }
  return context;
};